import {
	combineReducers,
	configureStore,
	getDefaultMiddleware
} from '@reduxjs/toolkit';
import {
	FLUSH,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
	REHYDRATE,
	persistReducer,
	persistStore
} from 'redux-persist';
import type { PersistConfig } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import configurationReducer from './ConfigurationSlice';
import type { ConfigurationSliceState } from './ConfigurationSlice';
import playthroughReducer, { newPlaythrough } from './PlaythroughSlice';
import highscoreReducer from './HighscoreSlice';
import type { HighscoreSliceState } from './HighscoreSlice';
import ratingReducer from './RatingSlice';
import { IS_DEBUG } from '../utils/debug';

const configurationPersistConfig: PersistConfig<ConfigurationSliceState> = {
	key: 'Configuration',
	storage,
	debug: IS_DEBUG
};

const highscorePersistConfig: PersistConfig<HighscoreSliceState> = {
	key: 'Highscore',
	storage,
	debug: IS_DEBUG
};

const rootReducer = combineReducers({
	configuration: persistReducer(
		configurationPersistConfig,
		configurationReducer
	),
	playthrough: playthroughReducer,
	highscore: persistReducer(highscorePersistConfig, highscoreReducer),
	rating: ratingReducer
});
export type RootState = ReturnType<typeof rootReducer>;

const persistConfig: PersistConfig<RootState> = {
	key: 'MiniLautern',
	storage,
	whitelist: [],
	debug: IS_DEBUG
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
	devTools: {
		name: 'MiniLautern Redux'
	},
	middleware: getDefaultMiddleware({
		/*
		 * Fix for error: A non-serializable value was detected in an action
		 * see https://github.com/rt2zz/redux-persist/issues/988
		 */
		serializableCheck: {
			ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
		}
	}),
	reducer: persistedReducer
});

const persistor = persistStore(store, null, () => {
	store.dispatch(newPlaythrough({}));
});

export default store;
export { persistor };
export type AppDispatch = typeof store.dispatch;
